/**
 * Случайность для практики — на криптографическом генераторе браузера.
 * <p>
 * `Math.random()` предсказуем: по нескольким выданным числам восстанавливается
 * состояние генератора, а значит и следующие. Правильный ответ и так лежит в данных
 * карточки, поэтому предсказание порядка вариантов сегодня ничего не даёт, — но
 * генератор один на всё приложение, и стоит однажды взять его для чего-то, что
 * угадывать нельзя, как предсказуемость станет дырой. Дешевле не заводить второго
 * генератора вовсе.
 * <p>
 * `crypto.getRandomValues` есть во всех целевых браузерах; в тестах его подкладывает
 * setupTests.js из webcrypto Node.
 */

/** Сколько значений помещается в Uint32: верхняя граница выдачи генератора. */
const UINT32_RANGE = 2 ** 32;

/**
 * Случайное целое в диапазоне [0, bound).
 * <p>
 * Остаток от деления брать напрямую нельзя: 2^32 на bound обычно не делится нацело,
 * и первые значения диапазона выпадали бы чаще остальных. Поэтому хвост, который не
 * укладывается в целое число полных периодов, отбрасывается и число берётся заново —
 * повтор здесь маловероятен настолько, что цикл почти всегда заканчивается на первом
 * же значении.
 */
export const randomInt = (bound) => {
    if (!Number.isInteger(bound) || bound <= 0) {
        throw new RangeError(`randomInt ожидает положительное целое, получено ${bound}`);
    }
    const usable = Math.floor(UINT32_RANGE / bound) * bound;
    const buffer = new Uint32Array(1);
    let value;
    do {
        crypto.getRandomValues(buffer);
        [value] = buffer;
    } while (value >= usable);
    return value % bound;
};

/**
 * Перемешанная копия массива, алгоритм Фишера — Йетса. Исходный массив не трогается:
 * порядок вариантов в карточке считается заново на каждый вопрос, а данные слова
 * приходят общими на всё окно практики.
 */
export const shuffled = (items) => {
    const copy = [...items];
    for (let i = copy.length - 1; i > 0; i--) {
        const j = randomInt(i + 1);
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy;
};
